export enum NephilimErrorCodesEnum {
    Unknown = 0,
    Validation = 1,
    InsufficientPermissions = 2,
    PatchActionIsNotAllowed = 3,
    ProductUsageIsNotPermitted = 4,
}
